// config.js or constants.js

export const API_ENDPOINT = "https://choozplatform.com/rnd_be-main/";
